import React from "react";
import logo from "../assets/images/Liifer_logo_max.png";
import warningIcon from "../assets/svg/warning-outline.svg";
import cancelSvg from "../assets/svg/x.svg";

interface NotificationBannerPropsInterface {
  message: any;
  backgroundColor?: any;
  warning?: boolean;
  closeFunction?: () => any;
}

export const NotificationBanner: React.FC<NotificationBannerPropsInterface> = ({
  message,
  closeFunction,
  backgroundColor,
  warning,
}) => {
  return (
    <div
      className="flex items-center w-full whitespace-normal mb-1 justify-between p-1 h-auto md:h-7 3xl:h-8 rounded-lg shadow-lg text-lg 3xl:text-xl"
      style={{
        backgroundColor: backgroundColor ? backgroundColor : "#242E3B",
        color: "white",
      }}
    >
      <div className="flex items-center w-full text-center md:text-left">
        {warning ? (
          <img
            className="h-5 3xl:h-6 px-1 md:px-2"
            src={warningIcon}
            alt="error symbol"
          />
        ) : (
          <img className="h-4 3xl:h-5 pr-1 3xl:pr-2" src={logo} alt="logo" />
        )}
        <div className="flex-1 px-2">
          <small className="break-words">{message}</small>
        </div>
      </div>
      {!!closeFunction && (
        <button onClick={closeFunction} className="ml-2">
          <img className="h-4" src={cancelSvg} alt="cancel" />
        </button>
      )}
    </div>
  );
};
